import apiClient from './api-client'
import type {
  ChargingFeedbackMessagesResponse,
  ChargingPlanRequest,
  ExecuteChargingPlanResponse,
  VehicleCommandResponse,
  VehiclePlanCalculationDataResponse,
  VehicleTelemetryMessagesResponse,
} from '../types/charging-steering.types'

export async function startCharging(vin: string): Promise<VehicleCommandResponse> {
  const { data } = await apiClient.post<VehicleCommandResponse>(`/v1/vehicles/${vin}/start`)
  return data
}

export async function stopCharging(vin: string): Promise<VehicleCommandResponse> {
  const { data } = await apiClient.post<VehicleCommandResponse>(`/v1/vehicles/${vin}/stop`)
  return data
}

export async function fetchCalculationData(
  vin: string,
): Promise<VehiclePlanCalculationDataResponse> {
  const { data } = await apiClient.get<VehiclePlanCalculationDataResponse>(
    `/v1/vehicles/${vin}/calculation-data`,
  )
  return data
}

export async function executeChargingPlan(
  vin: string,
  request: ChargingPlanRequest,
): Promise<ExecuteChargingPlanResponse> {
  const { data } = await apiClient.post<ExecuteChargingPlanResponse>(
    `/v1/vehicles/${vin}/charging-plan`,
    request,
  )
  return data
}

export async function fetchTelemetryMessages(
  vin: string,
  from: string,
): Promise<VehicleTelemetryMessagesResponse> {
  const { data } = await apiClient.get<VehicleTelemetryMessagesResponse>(
    `/v1/vehicles/${vin}/telemetry-messages`,
    {
      params: { from },
    },
  )
  return data
}

export async function fetchChargingFeedbackMessages(
  vin: string,
  from: string,
): Promise<ChargingFeedbackMessagesResponse> {
  const { data } = await apiClient.get<ChargingFeedbackMessagesResponse>(
    `/v1/vehicles/${vin}/charging-plan/status`,
    {
      params: { from },
    },
  )
  return data
}
